module.exports = __webpack_public_path__ + "img/Kinesis-Stream-Logo.f2c15fac.png";